import { Component, Input } from "@angular/core";
import { IconShareComponent } from "../../../components/svg/icon-share/icon-share.component";

@Component({
  selector: "app-rrss-buttons",
  imports: [IconShareComponent],
  templateUrl: "./rrss-buttons.component.html",
  styleUrl: "./rrss-buttons.component.scss",
})
export class RrssButtonsComponent {
  @Input() text;
  @Input() url;
  rrssVisible = false;

  mostrarRRSS(): void {
    this.rrssVisible = !this.rrssVisible;
  }
}
